import { isoOf, isWeekend } from './calendar';
import { allBorders, center, COL, fill, forEachDay, round, ROW } from './layout';

// Sous-total d'un mois dans la gouttière (cellule vide quand il est nul).
function writeGutter(ws, rowIdx, mo, value, font) {
  const g = ws.getCell(rowIdx, mo.gutter);
  if (value) g.value = round(value);
  if (font) g.font = font;
  g.alignment = center();
  g.fill = fill(COL.month);
  return g;
}

function writeCategoryRow(ws, { year, months, dateCol }, rowIdx, cat, opts = {}) {
  const labelCell = ws.getCell(rowIdx, 1);
  labelCell.value = cat.label;
  if (opts.labelFill) labelCell.fill = fill(opts.labelFill);
  // total annuel
  const tot = ws.getCell(rowIdx, 2);
  tot.value = cat.total ? round(cat.total) : 0;
  tot.font = { bold: true };
  tot.alignment = center();
  // sous-totaux mensuels + valeurs par jour
  for (const mo of months) {
    const mv = cat.monthly[mo.m];
    writeGutter(ws, rowIdx, mo, mv, mv ? { bold: true, size: 9 } : null);
    forEachDay(year, mo, dateCol, (iso, dt, col) => {
      const v = cat.byIso.get(iso);
      const c = ws.getCell(rowIdx, col);
      if (v) c.value = round(v);
      c.alignment = center();
      c.font = { size: 9 };
    });
  }
}

// Ligne Total (somme de toutes les catégories par jour)
export function writeTotalRow(ws, { year, months, dateCol }, cats) {
  ws.getCell(ROW.TOTAL, 1).fill = fill(COL.totalRow);
  let yearTot = 0;
  for (const mo of months) {
    let monthTot = 0;
    for (let d = 1; d <= mo.dim; d++) {
      const iso = isoOf(year, mo.m, d);
      let s = 0;
      for (const cat of cats.values()) s += cat.byIso.get(iso) || 0;
      const c = ws.getCell(ROW.TOTAL, dateCol.get(iso));
      if (s) c.value = round(s);
      c.alignment = center();
      c.font = { size: 9, bold: true };
      monthTot += s;
      yearTot += s;
    }
    writeGutter(ws, ROW.TOTAL, mo, monthTot, { bold: true, size: 9 });
  }
  const tb = ws.getCell(ROW.TOTAL, 2);
  tb.value = round(yearTot);
  tb.font = { bold: true };
  tb.alignment = center();
}

// Catégories : absences, puis section Projet, puis projets, puis Autre. Renvoie la dernière ligne.
export function writeCategoryRows(ws, grid, { absRows, projectRows, autreRow }) {
  let r = ROW.FIRST_CAT;
  for (const cat of absRows) writeCategoryRow(ws, grid, r++, cat, { labelFill: COL.week });
  const sec = ws.getCell(r, 1);
  sec.value = 'Projet';
  sec.font = { bold: true };
  sec.fill = fill(COL.month);
  ws.getCell(r, 2).fill = fill(COL.month);
  r++;
  for (const cat of projectRows) writeCategoryRow(ws, grid, r++, cat, {});
  if (autreRow) writeCategoryRow(ws, grid, r++, autreRow, { labelFill: COL.week });
  return r - 1;
}

// Ombrage week-end / fériés sur toute la hauteur, puis bordures sur toute la grille.
export function shadeAndBorder(ws, { year, months, dateCol, lastCol, feries }, lastRow) {
  for (const mo of months)
    forEachDay(year, mo, dateCol, (iso, dt, c) => {
      const shade = feries.has(iso) ? COL.ferie : isWeekend(dt) ? COL.weekend : null;
      if (!shade) return;
      for (let row = ROW.TOTAL; row <= lastRow; row++) {
        const cell = ws.getCell(row, c);
        if (!cell.fill || cell.fill.type !== 'pattern') cell.fill = fill(shade);
      }
    });
  for (let row = ROW.TITLE; row <= lastRow; row++)
    for (let c = 1; c <= lastCol; c++) ws.getCell(row, c).border = allBorders;
}
